import { ofType } from "redux-observable";
import { map, switchMap } from "rxjs/operators";
import { actionAddPelletsAnimations, TypeActionAnimations, } from "../actionPelletAnimations";
export var epicScreenSpaceAnimation = function (action$, state$, deps) {
    return deps.inStoreDependencies.viewportChanged$.pipe(switchMap(function (viewport) {
        return action$.pipe(ofType(TypeActionAnimations.AddPelletsInScreenCenter), map(function (action) {
            var origin = {
                x: (Math.abs(viewport.x) + window.innerWidth * 0.5) / viewport.scale.x,
                y: (Math.abs(viewport.y) + window.innerHeight * 0.5) / viewport.scale.y,
            };
            return actionAddPelletsAnimations(action.id, action.rewards, origin);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/epics/epicScreenSpaceAnimation.ts
// module id = 1769
// module chunks = 3